import moment from 'moment';

export const ColorMap = {
  'ORDER CREATED': 'blue',
  'ADDED TO MARKETPLACE': 'blue',
  PURCHASED: 'blue',
  'PENDING DELIVERY': 'orange',
  'PENDING APPROVAL': 'orange',
  OOS: 'geekblue',
  'PO CANCELLED': 'red',
  REJECTED: 'red',
  APPROVED: 'green',
  COMPLETED: 'green',
  'PENDING INVOICE SUBMISSION': 'orange',
  'PENDING PAYMENT': 'orange',
  PAID: 'green',
  REFUNDED: 'red',
};
export enum OrderOperationStatus {
  ORDER_CREATED = 'ORDER CREATED',
  ADDED_TO_MARKETPLACE = 'ADDED TO MARKETPLACE',
  PURCHASED = 'PURCHASED',
  PENDING_DELIVERY = 'PENDING DELIVERY',
  PENDING_APPROVAL = 'PENDING APPROVAL',
  OOS = 'OOS',
  PO_CANCELLED = 'PO CANCELLED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
}

export enum OrderPaymentStatus {
  PENDING_INVOICE_SUBMISSION = 'PENDING INVOICE SUBMISSION',
  INVOICE_DISPUTED = 'INVOICE_DISPUTED',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PENDING_PAYMENT = 'PENDING PAYMENT',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
}

export const formatQuotation = defaultValue => {
  const defaultFormValues = {
    lines: [
      { name: '', description: '', quantity: 1, total: 0, unit_price: 0 },
    ],
    tax: 0,
    currency: 'SGD',
    issue_date: moment(),
  };

  const initialValues = defaultValue
    ? {
        ...defaultFormValues,
        ...defaultValue,
        issue_date: defaultValue.issue_date
          ? moment.utc(defaultValue.issue_date)
          : moment(),
        validity_date: defaultValue.validity_date
          ? moment.utc(defaultValue.validity_date)
          : moment(),
        lines: defaultValue.lines.map(line => ({
          ...line,
        })),
      }
    : defaultFormValues;

  return initialValues;
};
